(function () {
    'use strict';

    angular
        .module('app')
        .factory('FieldTypesService', FieldTypesService);

    FieldTypesService.$inject = ['$http', '$q', 'UrlService'];

    function FieldTypesService($http, $q, UrlService) {
        var service = {
            getFieldTypes: getFieldTypes,
            getBsbDescription: getBsbDescription
        };

        return service;

        /*
         * Get the field types
         *
         * @param {bool} includeRelationshipFieldTypes - Should relationship field types also be returned. These are generated using the entity templates that exist.
         *
         * @returns {array} - List of field types {object}. Refer to the C# class FieldTypeViewModel.cs.
         */
        function getFieldTypes(includeRelationshipFieldTypes) {
            var requestUrl = UrlService.getWebAPIUrl() + '/fieldtype/';

            if (!_.isNil(includeRelationshipFieldTypes)) {
                requestUrl += '?includeRelationshipFieldTypes=' + includeRelationshipFieldTypes;
            }

            return $http.get(requestUrl).then(
                function (response) {
                    return response.data;
                });
        }

        function getBsbDescription(bsbNumber) {
            var requestUrl = UrlService.getWebAPIUrl() + '/bsb/' + bsbNumber;

            return $http.get(requestUrl).then(
                function (response) {
                    return response.data;
                });
        }
    }
})();